/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import MultipleQuestionsTemplate from '../../../pages/mobile/mental-health/MultipleQuestionsTemplate';
import MobileMultipleQuestionsSubmitTemplate from '../../../pages/mobile/mental-health/MultipleQuestionsSubmitTemplate';
import MobileMentalHealthInfo from '../../../pages/mobile/mental-health/MentalHealthInfo';
import MobileMentalHealthCompleteSurvey from '../../../pages/mobile/mental-health/MentalHealthCompleteSurvey';
import { ReactComponent as Warning } from '../../../assets/icons/warning.svg';
import { ReactComponent as DoctorMaleOrange } from '../../../assets/icons/doctor-male-orange.svg';
import { ReactComponent as DoctorMaleGreen } from '../../../assets/icons/doctor-male-green.svg';

const optionsSetA = [
  {
    label: 'mental-health:optionsSetA.notAtAll',
    value: 0,
  },
  {
    label: 'mental-health:optionsSetA.severalDays',
    value: 1,
  },
  {
    label: 'mental-health:optionsSetA.moreThanHalf',
    value: 2,
  },
  {
    label: 'mental-health:optionsSetA.nearlyEveryDay',
    value: 3,
  }
];

const optionsSetB = [
  {
    label: 'mental-health:optionsSetB.notDifficultAtAll',
    value: 0,
  },
  {
    label: 'mental-health:optionsSetB.somewhatDifficult',
    value: 1,
  },
  {
    label: 'mental-health:optionsSetB.veryDifficult',
    value: 2,
  },
  {
    label: 'mental-health:optionsSetB.extremelyDifficult',
    value: 3,
  }
];

const instructionRoutes = [
  {
    id: '1',
    path: '/speak-doctor/mental-health-questions/infomation',
    component: (props) => <MobileMentalHealthInfo {...props} />,
    props: {
      isInstructionPage: true,
      heading: "mental-health:information.heading",
      instruction: {
        heading: "mental-health:information.description.heading",
        paragraph: "mental-health:information.description.paragraph",
        paragraph1: "mental-health:information.description.paragraph1"
      },
      navBttonText: "mental-health:information.navBtn",
      SvgIcon: () => <Warning />,
      prevRoutePath: '',
      nextRoutePath: '/speak-doctor/mental-health-questions/instructions',
      boxWidth: '320px',
      selectStyling: {
        maxWidth: '250px',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
    },
  },
  {
    id: '2',
    path: '/speak-doctor/mental-health-questions/instructions',
    component: (props) => <MobileMentalHealthInfo {...props} />,
    props: {
      isInstructionPage: true,
      heading: "mental-health:instruction.heading",
      instruction: {
        paragraph: "mental-health:instruction.description.paragraph",
        paragraph1: "mental-health:instruction.description.paragraph1"
      },
      nextRoutePath: '/speak-doctor/mental-health-questions/section-a',
      options: optionsSetA,
      // nextRoutePath: '',
      navBttonText: "mental-health:instruction.navBtn",
      boxWidth: '320px',
      selectStyling: {
        maxWidth: '250px',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
    },
  },
  {
    id: '3',
    path: '/speak-doctor/mental-health-questions/complete-survey-red',
    component: (props) => <MobileMentalHealthCompleteSurvey {...props} />,
    props: {
      isInstructionPage: true,
      isRedColor: true,
      isSurveyCompleted: true,
      heading: "mental-health:completeSurvey.heading",
      SvgIcon: () => <DoctorMaleOrange />,
      instruction: {
        paragraph: "mental-health:completeSurveyRed.description.paragraph",
        paragraph1: "mental-health:completeSurveyRed.description.paragraph1"
      },
      prevRoutePath: '',
      nextRoutePath: '/',
      text: "mental-health:completeSurveyRed.text",
      boxWidth: '320px',
      selectStyling: {
        maxWidth: '250px',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
    },
  },
  {
    id: '4',
    path: '/speak-doctor/mental-health-questions/complete-survey-green',
    component: (props) => <MobileMentalHealthCompleteSurvey {...props} />,
    props: {
      nextRoutePath: '/',
      isInstructionPage: true,
      isSurveyCompleted: true,
      heading: "mental-health:completeSurvey.heading",
      SvgIcon: () => <DoctorMaleGreen />,
      instruction: {
        paragraph: "mental-health:completeSurveyGreen.description.paragraph"
      },
      text: "mental-health:completeSurveyGreen.text",
      navBttonText: "Get Started",
      boxWidth: '320px',
      selectStyling: {
        maxWidth: '250px',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
    },
  },
];

const mentalHealthScreening = [
  {
    id: '1',
    path: '/speak-doctor/mental-health-questions/section-a',
    component: (props) => <MultipleQuestionsTemplate {...props} />,
    props: {
      prevRoutePath: '/speak-doctor/mental-health-questions/instructions',
      nextRoutePath: '/speak-doctor/mental-health-questions/section-b',
      section: {
        label: "mental-health:section-a.name",
        value: "sectionA"
      },
      questions: [
        {
          label: "mental-health:section-a.question-1.littleInterest",
          value: "LittleInterestOrPleasureDoingThings",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-2.feelingDown",
          value: "FeelingDownDepressedHopeless",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-3.troubleFalling",
          value: "TroubleFallingStayingAsleepSleepingTooMuch",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-4.feelingTired",
          value: "FeelingTiredHavingLittleEnergy",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-5.poorAppetite",
          value: "PoorAppetiteOvereating",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-6.feelingBad",
          value: "FeelingBadAboutYourself",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-7.troubleConcentrating",
          value: "TroubleConcentrating",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-8.movingOrSpeaking",
          value: "MovingSpeaking",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-9.thoughtsThatYou",
          value: "ThoughtsOfDead",
          options: optionsSetA
        },
        {
          label: "mental-health:section-a.question-10.ifYouChecked",
          value: "IfYouCheckedOffAnyProblems",
          options: optionsSetB
        }
      ],
      boxWidth: '320px',
      selectStyling: {
        maxWidth: '250px',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
      bodyStyle: {
        paddingTop: '30px'
      },
    },
  },
  {
    id: '2',
    path: '/speak-doctor/mental-health-questions/section-b',
    component: (props) => <MultipleQuestionsTemplate {...props} />,
    props: {
      prevRoutePath: '/speak-doctor/mental-health-questions/section-a',
      nextRoutePath: '/speak-doctor/mental-health-questions/section-c',
      section: {
        label: "mental-health:section-b.name",
        value: "sectionB"
      },
      questions: [
        {
          label: "mental-health:section-b.question-1.feelingNervous",
          value: "FeelingNervousAnxious",
          options: optionsSetA
        },
        {
          label: "mental-health:section-b.question-2.notBeingAble",
          value: "NotBeingAbleToControlWorrying",
          options: optionsSetA
        },
        {
          label: "mental-health:section-b.question-3.worryingTooMuch",
          value: "WorryingTooMuchAboutDifferentThings",
          options: optionsSetA
        },
        {
          label: "mental-health:section-b.question-4.troubleRelaxing",
          value: "TroubleRelaxing",
          options: optionsSetA
        },
        {
          label: "mental-health:section-b.question-5.beingSoRestless",
          value: "BeingRestless",
          options: optionsSetA
        },
        {
          label: "mental-health:section-b.question-6.becomingEasily",
          value: "BecomingEasilyAnnoyedIrritable",
          options: optionsSetA
        },
        {
          label: "mental-health:section-b.question-7.feelingAfraid",
          value: "FeelingAfraid",
          options: optionsSetA
        },
        {
          label: "mental-health:section-b.question-8.ifYouChecked",
          value: "IfYouCheckedOffAnyProblems",
          options: optionsSetB
        }
      ],
      boxWidth: '320px',
      selectStyling: {
        maxWidth: '250px',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
      bodyStyle: {
        paddingTop: '30px'
      },
    },
  },
  {
    id: '3',
    path: '/speak-doctor/mental-health-questions/section-c',
    component: (props) => <MultipleQuestionsTemplate {...props} />,
    props: {
      prevRoutePath: '/speak-doctor/mental-health-questions/section-b',
      nextRoutePath: '/speak-doctor/mental-health-questions/section-d',
      section: {
        label: "mental-health:section-c.name",
        value: "sectionC"
      },
      questions: [
        {
          label: "mental-health:section-c.question-1.feelSoAfraid",
          value: "FeelAfraidNothingCalmDown",
          options: optionsSetA
        },
        {
          label: "mental-health:section-c.question-2.feelSoAngry",
          value: "FeelAngryOutOfControl",
          options: optionsSetA
        },
        {
          label: "mental-health:section-c.question-3.feelSoUninterested",
          value: "FeelUninterestedInThings",
          options: optionsSetA
        },
        {
          label: "mental-health:section-c.question-4.feelSoHopeless",
          value: "FeelHopeless",
          options: optionsSetA
        },
        {
          label: "mental-health:section-c.question-5.feelSoSeverely",
          value: "FeelSeverelyUpset",
          options: optionsSetA
        },
        {
          label: "mental-health:section-c.question-6.feelUnableTo",
          value: "FeelUnableToCarryEssentialActivities",
          options: optionsSetA
        }
      ],
      boxWidth: '320px',
      selectStyling: {
        maxWidth: '250px',
        marginLeft: 'auto',
        marginRight: 'auto'
      },
      bodyStyle: {
        paddingTop: '30px'
      },
    },
  },
];

const mentalHealthSymptomsRoutes =[
    {
      id: '4',
      path: '/speak-doctor/mental-health-questions/section-d',
      component: (props) => <MobileMultipleQuestionsSubmitTemplate {...props} />,
      props: {
        prevRoutePath: '/speak-doctor/mental-health-questions/section-b',
      //   nextRoutePath: '',
        section: {
          label: "mental-health:section-d.name",
          value: "sectionD"
        },
        isLabelHidden: true,
        isLastQuestion: true,
        isSubmit: true,
        title: "mental-health:mentalHealthSymptoms",
        question: {
          label: "mental-health:section-d.question-1.writeYourAnswer",
          value: "mentalHealthDifficulties",
          rows: 10
        },
        boxWidth: '320px',
        selectStyling: {
          maxWidth: '250px',
          marginLeft: 'auto',
          marginRight: 'auto'
        },
        bodyStyle: {
          paddingTop: '30px',
        },
      },
    },
];

export const getInstructionRoutes = () => instructionRoutes;
export const getMentalHealthScreening = () => mentalHealthScreening;
export const getmentalHealthSymptomsRoutes = () => mentalHealthSymptomsRoutes;
